import React, { useEffect, useState } from "react";
import "./HeaderLeft.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const isMobileDevice = () => window.matchMedia("(max-width: 1000px)").matches;

const BASE_NEW_USER_TABS = [
  { title:"Home",      name:"/",                normalImg:"/images/home-icon.svg",        selectedImg:"/images/home-icon-orange.svg" },
  { title:"Product",   name:"/product",         normalImg:"/images/products-icon.svg",    selectedImg:"/images/products-orange-icon.svg" },
  { title:"Solutions", name:"/solutions",       normalImg:"/images/solutions-icon.svg",   selectedImg:"/images/solutions-orange-icon.svg" },
  { title:"Pricing",   name:"/pricing",         normalImg:"/images/price-icon.svg",       selectedImg:"/images/price-orange.svg" },
  { title:"Blog",      name:"/blog",            normalImg:"/images/blog-icon.svg",        selectedImg:"/images/blog-orange-icon.svg" },
  { title:"T&S",       name:"/termsConditions", normalImg:"/contract-white.png",          selectedImg:"/contract-orange.png" },
];

const MOBILE_CLOSE_TAB = { title:"Close", name:"", normalImg:"/up-Arrow.png", selectedImg:"/up-Arrow.png" };

const PARENT_USER_TABS = [
  { title:"VM",         name:"/vm/create",     normalImg:"/admin/images/admin/menu/vm-white.png",           selectedImg:"/admin/images/admin/menu/vm-orange.svg" },
  { title:"CDN",        name:"/vm/cdn",        normalImg:"/admin/images/admin/menu/cdn.svg",                selectedImg:"/images/cdn-orange.svg" },
  { title:"Billing",    name:"/bill",          normalImg:"/admin/images/admin/menu/price-tag.svg",          selectedImg:"/admin/images/admin/menu/price-orange.svg" },
  { title:"Support",    name:"/create-ticket", normalImg:"/admin/images/admin/menu/online_support.svg",     selectedImg:"/admin/images/admin/menu/online_support-orange.svg" },
  { title:"Monitoring", name:"/vm/monitor",    normalImg:"/admin/images/admin/menu/monitoring.svg",         selectedImg:"/admin/images/admin/menu/monitoring-orange.svg" },
  { title:"AddOns ", name:"/addon-services",   normalImg:"/admin/images/addon.png",                         selectedImg:"/admin/images/addon.png" },
];

const CHILD_USER_TABS = [
  { title:"CDN",        name:"/vm/cdn",        normalImg:"/admin/images/admin/menu/cdn.svg",                selectedImg:"/images/cdn-orange.svg" },
  { title:"Support",    name:"/create-ticket", normalImg:"/admin/images/admin/menu/online_support.svg",     selectedImg:"/admin/images/admin/menu/online_support-orange.svg" },
  { title:"Monitoring", name:"/vm/monitor",    normalImg:"/admin/images/admin/menu/monitoring.svg",         selectedImg:"/admin/images/admin/menu/monitoring-orange.svg" },
];

const PATH_TO_TAB = {
  "/vm/create":"/vm/create", "/vm/cdn":"/vm/cdn",
  "/bill":"/bill", "/billreport":"/bill", "/paymentdata":"/bill",
  "/create-ticket":"/create-ticket", "/vm/monitor":"/vm/monitor",
  "/product":"/product", "/solutions":"/solutions",
  "/pricing":"/pricing", "/blog":"/blog", "/termsConditions":"/termsConditions",
};

// Only fix: icon images inside the circles are invisible because they're the
// same colour as the orange background. Force white on normal, orange-bg icons;
// keep selected icons (which are already orange-coloured PNGs) as-is.
const ICON_FIX_CSS = `
  /* Make icons visible inside the orange circle on the sidebar */
  .listing-mob .img-menu {
    width: 70px !important;
    height: 80px !important;
    object-fit: contain !important;
    display: block !important;
    margin: 0 auto !important;
    /* White filter so white SVGs show on orange background */
    filter: brightness(0) invert(1);
  }
  @media (max-width: 740px) {
    .listing-mob .img-menu {
      width: 43px !important;
      height: 29px !important;
    }
  }

  @media (max-width: 576px) {
      .img-menu {
          padding: 0px 5px 0px 0px !important;
      }
  }
  /* Selected tab uses the orange-coloured image — remove the white filter */
  .border-selected .img-menu {
    filter: none !important;
    
  }
  /* Center the icon inside the figure */
  .listing-mob figure {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`;


const TabList = ({ tabs, activeTab, onTabClick, listStyle, itemStyle }) => (
  <ul className="see-full listing-mob" style={listStyle}>
    {tabs.map((item, idx) => (
      <li key={idx}>
        <a>
          <div
            className={activeTab === item.name ? "border-selected" : "border"}
            onClick={() => onTabClick(item)}
          >
            <figure style={itemStyle}>
              <img
                className="img-menu"
                src={activeTab === item.name ? item.selectedImg : item.normalImg}
                alt={item.title}
                style={{
                  height: "28px",
                  width: "28px",
                  marginLeft:
                    item.title === "T&S" ? "5px" :
                    item.title === "Solutions" ? "3px" : "0px",
                }}
              />
            </figure>
            <div className="heading">{item.title}</div>
          </div>
        </a>
      </li>
    ))}
  </ul>
);

const HeaderLeft = () => {
  const { smuser, isLoginByParentUser } = useAuth();
  const location  = useLocation();
  const navigate  = useNavigate();

  const urlParts    = window.location.pathname.split("/");
  const lastElement = urlParts[urlParts.length - 2];

  const [showFooter,  setShowFooter]  = useState(true);
  const [isMobile,    setIsMobile]    = useState(isMobileDevice);
  const [menuVisible, setMenuVisible] = useState(!isMobileDevice());
  const [activeTab,   setActiveTab]   = useState("/");
  const [isLogged,    setIsLogged]    = useState(true);

  const newUserTabs = isMobile ? [...BASE_NEW_USER_TABS, MOBILE_CLOSE_TAB] : BASE_NEW_USER_TABS;
  const UserTabs    = isLoginByParentUser == 1 ? PARENT_USER_TABS : CHILD_USER_TABS;

  useEffect(() => {
    setIsLogged(!!smuser);
    setMenuVisible(!isMobileDevice());
    setShowFooter(lastElement !== "reset_password");

    const handleResize = () => {
      const mobile = isMobileDevice();
      setIsMobile(mobile);
      setMenuVisible(!mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const tab = PATH_TO_TAB[location.pathname];
    if (tab) setActiveTab(tab);
  }, [location.pathname]);

  const toggleMenu = () => setMenuVisible((v) => !v);

  const handleTabClick = (item, closeMobileMenu = false) => {
    setActiveTab(item.name);
    navigate(item.name);
    if (closeMobileMenu) toggleMenu();
  };

  return (
    <>
      <style>{ICON_FIX_CSS}</style>
      {showFooter && (
        <>
          {isMobile ? (
            !isLogged && (
              <div className="header-left h-auto">
                <div className="main see-full">
                  <div className="menu" style={{ position:"relative", zIndex:"999999999999" }}>
                    <a onClick={toggleMenu}>
                      <figure style={{ padding:"5px", marginTop:"15px", marginBottom:"20px" }}>
                        <img src="/images/menu.svg" alt="Menu" style={{ width:"20px", marginLeft:"25px" }} />
                      </figure>
                    </a>
                  </div>
                  <div className={`listing see-full ${menuVisible ? "" : "hide"}`}>
                    <TabList
                      tabs={newUserTabs}
                      activeTab={activeTab}
                      onTabClick={(item) => handleTabClick(item, true)}
                      listStyle={{ paddingLeft:"0rem", paddingBottom:"10px", marginLeft:"11px" }}
                      itemStyle={{ textAlign:"center", paddingTop:"15px" }}
                    />
                  </div>
                </div>
              </div>
            )
          ) : (
            <div className="header-left h-auto">
              <div className="main see-full">
                <div className="menu">
                  <a onClick={toggleMenu}>
                    <figure style={{ padding:"25px" }}>
                      <img src="/images/menu.svg" alt="Menu" style={{ padding:"10px", width:"60px", marginTop:"4px" }} />
                    </figure>
                  </a>
                </div>
                <div className={`listing see-full ${menuVisible ? "" : "hide"}`} style={{ display: menuVisible ? "block" : "none" }}>
                  <TabList
                    tabs={isLogged ? UserTabs : newUserTabs}
                    activeTab={activeTab}
                    onTabClick={(item) => handleTabClick(item)}
                    listStyle={{ paddingLeft:"12px", paddingBottom:"15px" }}
                    itemStyle={{ marginBottom:"2px" }}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default HeaderLeft;